// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_kzZyZ {
  width: 496px;
  height: 232px;
  display: flex;
  flex-direction: column;
}

.cancelButton_qRLyh {
  max-width: 120px;
}


.dialogHeader_Ym9UV {
  height : 48px;
  padding: var(--size-pad12) var(--size-padLarge);
  border-bottom: 1px solid var(--color-base100);
}

.headerIcon_cuYqE {
  background-color: #D0EBFF;
  width: 24px;
  height: 24px;
}
.headerIcon_cuYqE > i {
  font-size: 10px;
}

.dialogBody_yBQo9 {
  height : 112px;
  background-color: 'white';
}
.dialogBody_yBQo9 > * + * {
  margin-top: var(--size-padLarge);
}

.dialogBodyText_N_Kp0 {
  font-size : 16px;
  padding : 16px;
  position : relative;
}

.dialogFooter_WyX9j {
  height : 72px;
  padding: var(--size-padLarge);
}

.formLabel_wEokL {
  margin-bottom: var(--size-padSmall);
}

/* Overriding default Toast's styling */
.toast_KQLZQ {
  border-radius: var(--size-borderRadiusMedium) !important;
  min-height: 40px !important;
  padding: var(--size-padMedium) !important;
}
.toast_KQLZQ > button {
  margin-top: 0 !important;
  width: 24px !important;
  height: 24px !important;
}

.icon_ojTwl {
  width: 24px;
  margin-left : 8px;
  margin-right : 8px;
}

.input_CPKvY {
  padding-left : 0px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/recovrGeneric/ownershipTransfer/actions/completeAssetTransfer/CancelTransferClasses.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,uCAAuC;AACvC;EACE,wDAAwD;EACxD,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".dialog {\n  width: 496px;\n  height: 232px;\n  display: flex;\n  flex-direction: column;\n}\n\n.cancelButton {\n  max-width: 120px;\n}\n\n\n.dialogHeader {\n  height : 48px;\n  padding: var(--size-pad12) var(--size-padLarge);\n  border-bottom: 1px solid var(--color-base100);\n}\n\n.headerIcon {\n  background-color: #D0EBFF;\n  width: 24px;\n  height: 24px;\n}\n.headerIcon > i {\n  font-size: 10px;\n}\n\n.dialogBody {\n  height : 112px;\n  background-color: 'white';\n}\n.dialogBody > * + * {\n  margin-top: var(--size-padLarge);\n}\n\n.dialogBodyText {\n  font-size : 16px;\n  padding : 16px;\n  position : relative;\n}\n\n.dialogFooter {\n  height : 72px;\n  padding: var(--size-padLarge);\n}\n\n.formLabel {\n  margin-bottom: var(--size-padSmall);\n}\n\n/* Overriding default Toast's styling */\n.toast {\n  border-radius: var(--size-borderRadiusMedium) !important;\n  min-height: 40px !important;\n  padding: var(--size-padMedium) !important;\n}\n.toast > button {\n  margin-top: 0 !important;\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.icon {\n  width: 24px;\n  margin-left : 8px;\n  margin-right : 8px;\n}\n\n.input {\n  padding-left : 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_kzZyZ`,
	"cancelButton": `cancelButton_qRLyh`,
	"dialogHeader": `dialogHeader_Ym9UV`,
	"headerIcon": `headerIcon_cuYqE`,
	"dialogBody": `dialogBody_yBQo9`,
	"dialogBodyText": `dialogBodyText_N_Kp0`,
	"dialogFooter": `dialogFooter_WyX9j`,
	"formLabel": `formLabel_wEokL`,
	"toast": `toast_KQLZQ`,
	"icon": `icon_ojTwl`,
	"input": `input_CPKvY`
};
export default ___CSS_LOADER_EXPORT___;
